<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Add Course Videos</v-flex>   
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex>
                        <v-radio-group v-model="Video_Type" row>
                            <v-radio label="Course Video" value="Course_Video"></v-radio>
                            <v-radio label="Course Preview Video" value="Course_Preview_Video"></v-radio>
                        </v-radio-group>
                    </v-flex>
                      <v-flex wrap style="padding: 10px;">
                            <!-- <v-flex>
                                <v-select v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title"></v-select>
                            </v-flex> -->

                            <!-- _in | Select Module Title Dropdown -->
                            <v-flex>
                                <v-select item-value='Course_Id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title" @change="GetCourseSectionList">
                                    <template slot='selection' slot-scope='{ item }'>
                                            {{ item.Course_Title }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                            {{ item.Course_Title }}
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-flex>
                                <v-select item-value='_id' item-text='name' return-object v-model="SelectedSection" :items="GetSectionList" label="Select Module Title">
                                    <template slot='selection' slot-scope='{ item }'>
                                            {{ item.Section_Title }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                            {{ item.Section_Title }}
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-flex>
                                <v-radio-group v-model="Upload_Type" row>
                                    <v-radio label="Upload Video" value="Upload_Video" @click="removeFrame()"></v-radio>
                                    <v-radio label="Embed Video" value="Embed_Video" @click="removePlayer()"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <div id="youtubeContainer" v-if="Upload_Type == 'Embed_Video'" style="">
                                <input type="text" name="youtubeUrl" id="youtubeUrl" v-model="Youtube_Url" placeholder="Enter embed code"/>
                            </div>


                            <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                                <v-flex id="doEmbed" v-if="Upload_Type == 'Embed_Video'" style="background-size:contain;">

                                </v-flex>
                                <v-flex id="doUpload" v-if="Upload_Type == 'Upload_Video' & showPlayer">
                                    <video id="video_course" loop controls width="100%" :src="url" ></video>
                                </v-flex>
                                <v-layout row>
                                    <v-flex style="text-align: center;" v-if="Upload_Type == 'Upload_Video'">
                                        <v-btn color="primary" @click="$refs.inputUpload.click()">Upload Course Video</v-btn>
                                        <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile">
                                    </v-flex>
                                    <v-flex style="text-align: center;" v-else>
                                        <v-btn color="primary" @click="$refs.embedLink.click()">Embed Course Video</v-btn>
                                        <input v-show="false" ref="embedLink" type="button" @click="selectedLink(Youtube_Url)" >
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn v-if="Video_Type == 'Course_Video'" color="primary" @click="SubmitCourseVideo" :disabled="disabled">Add Course Video</v-btn>
                        <v-btn v-else @click="SubmitPreviewVideo" color="primary">Add Preview Video</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>


export default {
    props: ['dialog'],

    data(){
        return {
            SelectedCourseDetail    : "",
            url                     : null,
            Video                   : null,
            loaded                  : 0,
            Video_Type              : "Course_Video",
            Upload_Type             : "Upload_Video",
            SelectedSection         : "",
            Youtube_Url             : null,
            showPlayer              : false,
            disabled                : true
        }
    },
    computed:{
        GetCourseDetailList() {
            return this.$store.getters.GetCourseDetailsList
        },
        GetSectionList() {
            return this.$store.getters.GetCourseSection
        }
    },
    methods:{
         //  called from computed GetSectionList

        GetCourseSectionList(){
            let data = {}
            data["Course_Id"] = this.SelectedCourseDetail['_id']
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/getsections`,data)
                        .then(response => {

                            if(response["data"]["response"]){

                                this.$store.commit('SetCourseSection',response["data"]["response"]["Course_Curriculam"])
                                return this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getcoursedetails`,data)

                            } else{

                                this.$store.commit('SetCourseSection',null)
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Add Course Sections","Color":"red","Close": false });

                            }

                        })
                        .then(response =>{

                            this.Current_Course_Details = response['data']['response']
                            this.Online = this.Current_Course_Details.Course_Types.includes('Online')

                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },

        GetCourseListFromDB(){
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        CloseDialog(){
            this.disabled = true;
            this.ClearForm()
            this.$emit('close')

        },
        removeFrame() {
            console.log("cliucked")
            if (this.Video)
                this.disabled = false;
            else
                this.disabled = true;
            const frame = document.querySelector('iframe');
            if(frame != null) {
                frame.remove();
            }
            this.Upload_Type = 'Upload_Video'
        },
        removePlayer() {
            this.disabled=true;
            this.Upload_Type='Embed_Video'
        },
        SelectedFile(e){
            
            this.Video              = e.target.files[0]
            const fileName          = this.Video.name;
            const validExtension    = /(\.mp4|\.flv|\.mkv|\.avi|\.wmv)$/i;
            this.url                = URL.createObjectURL(this.Video);
            this.showPlayer         = true;
            if (this.SelectedCourseDetail) {
                if (validExtension.exec(fileName)){
                    this.disabled = false;
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Video Selected","Color":"green","Close": false });
                }
                else {
                    this.disabled = true;
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Select valid file!","Color":"red","Close": false });

                }
            }
        },
        selectedLink(yUrl) {
            if (yUrl.length > 0) {
                document.querySelector("#doEmbed").innerHTML = yUrl;
                var frame = document.querySelector("#doEmbed").lastElementChild
                frame.setAttribute('height', '200px');
                frame.setAttribute('width', '400px');
                console.log(document.querySelector("#doEmbed").lastElementChild);
                if (this.SelectedCourseDetail)
                    this.disabled = false;
            } else {
                document.querySelector("#doEmbed").innerHTML = "";
            }
        },
        SubmitCourseVideo(){

            debugger;
            var allSessionData = this.$store.getters.GetCourseSection;
            if (this.Upload_Type == 'Upload_Video') {
                if(this.Video && this.SelectedCourseDetail){
                    const fd = new FormData()

                    this.$eventHub.$emit('LOADING','true')
                    fd.append('Course_Video',this.Video,this.Video.name);
                    fd.append('Course_Id', this.SelectedCourseDetail["_id"]);
                    fd.append('Section_Title', this.SelectedSection['Section_Title']);

                    this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/addcoursevideos`,fd)
                                .then(response =>{
                                    
                                    this.$store.commit('UpdateCourseDetails',response['data']['response'])
                                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Course Video","Color":"green","Close": false });
                                    this.CloseDialog()
                                    this.$eventHub.$emit('LOADING','false')
                                })
                                .catch(err =>{
                                    this.$eventHub.$emit('LOADING','false')
                                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Course Video","Color":"red","Close": false });
                                })
                } else{
                    this.CloseDialog();
                    this.$eventHub.$emit('LOADING','false')
                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Select Course / Course Title / Upload Video","Color":"red","Close": false });
                }
            } else if (this.Upload_Type == "Embed_Video") {
                const frame = document.querySelector("iframe");
                if (frame != null) {
                    const frameSrc = frame.src;
                    console.log(frameSrc)
                    if (frameSrc.length > 0) {
                        const fd = {
                            'Course_Video': frameSrc,
                            'Section_Title': this.SelectedSection['Section_Title'],
                            'Course_Id': this.SelectedCourseDetail["_id"]
                        }
                        // console.log(this.SelectedCourseDetail["_id"]);
                        this.$eventHub.$emit('LOADING','true')

                        this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/addyoutubecoursevideos`, fd)
                            .then(response => {
                                debugger;
                                this.$store.commit('UpdateCourseDetails',response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Course Video","Color":"green","Close": false });
                                this.CloseDialog()
                                this.$eventHub.$emit('LOADING','false')
                            })
                            .catch(err => {
                                this.$eventHub.$emit('LOADING','false')
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Course Video","Color":"red","Close": false });
                            })
                    } else {
                        this.$$eventHub.$$emit('LOADING', 'false')
                        alert("Please Embed the video!")
                    }
                }else {
                    alert("Check the embeded link!")
                }
            } else {
                alert("Select Media!")
            }
        },
        SubmitPreviewVideo(){

            this.$eventHub.$emit('LOADING','true')
            const fd = new FormData()
            fd.append('Course_Preview_Video',this.Video,this.Video.name)
            fd.append('Course_Id',this.$store.getters.GetCourseDetailsList.find(x => x["Course_Title"] == this.SelectedCourseDetail)["_id"])
            let Preview_URL = `${this.$store.getters.GetProductionUrl}/coursepreviewvideo/addcoursepreviewvideo`
    
            this.$http.post(Preview_URL,fd)
                        .then(response =>{
                            console.log(response);
                            this.$store.commit('UpdateCourseDetails',response['data']['response'])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Video","Color":"green","Close": false });
                            this.CloseDialog() 
                            this.$eventHub.$emit('LOADING','false')  
                             
                        })
                        .catch(err =>{
                            this.$eventHub.$emit('LOADING','false')
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Video","Color":"red","Close": false });
                        })
            this.CloseDialog();
        },
        ClearForm(){
            this.SelectedSection = ""
            this.SelectedCourseDetail    = ""
            this.Video_Type              = "Course_Video"
            this.ClearVideo()
        },
        ClearVideo(){

            this.url        = null
            this.Video      = null
            this.Upload_Type = "Upload_Video"
            if (this.showPlayer) {
                this.$refs.inputUpload.value = ""
                document.getElementById('video_course').src = ''   
                document.getElementById('video_course').load() 
                this.showPlayer = false;    
            } else {
                this.Youtube_Url = "";
            }
        }
    }
}
</script>
<style scoped>

#youtubeUrl {
    border: none;
    outline: none;
    background: none;
    width: 100%;
    font-size: 16px;
}
#youtubeContainer {
    margin:16px 0; 
    border-bottom: 1px #555 solid;
    padding: 4px;
}
</style>
